export default "__VITE_ASSET__so26jsQB__"